<vp-header
	[editableInStoryblok]="_editable"
	[hideMenu]="hideMenu"
	[menuItems]="headerMenu"
	[metaMenu]="metaMenu"
	[title]="title"
	(languageSwitch)="onLanguageSwitch($event)"
/>
